import { ACCEPTED_XLS_MIME_TYPES, ACCEPTED_XLS_TYPES, MAX_FILE_SIZE } from '@/constants'
import { createFileSchema, numberSchema, stringSchema, unionSchema, objectSchema } from '@/schemas'

export const importSchema = objectSchema({
  website_id: unionSchema([numberSchema, stringSchema]),
  source: stringSchema,
  type: stringSchema,
  import_batch_id: stringSchema.optional(),
  file: createFileSchema({
    maxSize: MAX_FILE_SIZE,
    acceptedMimeTypes: ACCEPTED_XLS_MIME_TYPES,
    acceptedTypesDescription: ACCEPTED_XLS_TYPES,
    required: true,
  }),
})
